import React, { useState } from 'react'
import { Modal } from "antd";
import Close from "../../../../resources/imgs/modal/close.svg";
import { FaChevronRight } from "react-icons/fa";
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg"
import Manuel from "../../../../resources/imgs/assessment/characters/Manuel.png"
import Pamela from "../../../../resources/imgs/assessment/characters/Pamela.png"
import Trish from "../../../../resources/imgs/assessment/characters/Trish.png"
import Karl from "../../../../resources/imgs/assessment/characters/Karl.png"
import Joey from "../../../../resources/imgs/assessment/characters/Joey.svg"
import Reina from "../../../../resources/imgs/assessment/characters/Reina.svg"

export default function Index(props) {
  const [dishes, setDishes] = useState(["Steak", "Salmon", "Pasta", "Vegetarian", "Chicken", "Lamb"])
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="02." percent={2 / 8} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 2</div>
          <div className="module1-body">
            <div className="module1-title">Final Orders </div>
            <div className="module1-content1">
              Below are the final meal selections for each guest. Try to commit them to memory, as you will need to remember them in a later exercise.
            </div>
          </div>
        </div>
      </div>

      <div className="module1-dishes module1-dishes2">
        {new Array(6).fill(0).map((item, idx) =>
          <div className="module4-dish">
            <div>{ props.cardData[idx].name }</div>
            <img src={props.cardData[idx].img} />
            <div>{ dishes[idx] }</div>
          </div>
        )}
      </div>

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>

        <div
          className="assessment-next-btn"
          onClick={() => { props.nextPage() }}
        >
          Next{" "}
          <div
            style={{
              paddingTop: "5px",
              display: "inline-block",
            }}
          >
            <FaChevronRight color="white" size={16} />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            Now that you have finalized the 6 guests’ orders, it’s time to enter their orders into a computer that sends that information to the kitchen.  There’s one problem. The screen of the machine is broken, meaning you’ll have to enter their orders by replicating the pattern of buttons (and associated sounds) that correspond to each meal. 
          </div>
        </div>
      </Modal>
    </div>
  )
}
